'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article6() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Клиент
					</Typography>
					<Typography variant='p1'>
						Торгово-строительная компания, осуществляющая малоэтажное строительство «под ключ», обратился в
						true.code с задачей провести аудит и настроить контекстную рекламу в Яндекс.Директ. Одной из важных
						целей заказчика было прозрачное понимание эффективности работы канала и качества получаемого трафика,
						а также оценка качества поступающих обращений.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задача
					</Typography>
					<Typography variant='p1'>
						Провести аудит и настроить контекстную рекламу в Яндекс.Директ. Одной из важных целей заказчика было
						прозрачное понимание эффективности работы канала и качества получаемого трафика, а также оценка
						качества поступающих обращений.
					</Typography>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Предпроектное исследование
					</Typography>
					<Typography variant='p1'>
						Для успешной работы над проектом, маркетинговая команда true.code подготовила дорожную карту, которая
						включала ряд рабочих встреч с клиентом. На встречах были определены объем работ по настройке
						контекстной рекламы, выделены ключевые направления продвижения по услугам компании, определены
						бизнес-цели заказчика, а также согласованы сроки и география запуска рекламы.
					</Typography>
					<Typography variant='p1'>
						Далее мы провели предварительную оценку и спрогнозировали расход рекламного бюджета. Кроме того, был
						проведен анализ качества и релевантности поисковой выдачи по позициям конкурентов, что позволило
						построить наиболее эффективную стратегию продвижения. Наши специалисты также проанализировали
						юзабилити сайта и предложили рекомендации по увеличению конверсии. Определение ключевых метрик и
						постановка целей рекламных кампаний на первых этапах работ позволили прозрачно отслеживать
						эффективность рекламных кампаний.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Аналитика и коллтрекинг
					</Typography>
					<Typography variant='p1'>
						Мы подключили Яндекс.Метрику и коллтрекинг, что позволило получать подробную статистику о поступающем
						на сайт трафике и детально исследовать целевую аудиторию. С помощью коллтрекинга были зафиксированы
						конечные обращения потенциальных клиентов, пришедших с рекламного канала, также собирали базу
						полученных контактов и классифицировали их. Данная информация позволила эффективно оптимизировать
						работу рекламного канала.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/6-1.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='p1'>
						Также мы регулярно собирали статистику по работе рекламного канала, анализировали полученные данные и
						корректировали стратегию продвижения в зависимости от сезонности, конкуренции и других факторов,
						влияющих на эффективность работы канала.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Оценка качества лидов
					</Typography>
					<Typography variant='p1'>
						Благодаря настроенным синхронизациям между сервисами, мы смогли собирать данные о всех обращениях с
						сайта: звонки по номеру телефона и отправленные формы заявок, не только из рекламных систем. Чтобы
						отслеживать качество поступающих обращений, мы использовали систему присвоения классов и
						комментирования прямо внутри единого журнала лидов совместно с клиентом. Синхронизация с CRM-системой
						позволила получить данные об источниках лидов в карточки сделок внутри CRM и отслеживать изменение
						статуса сделки до ее закрытия.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/6-2.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Ведение рекламных кампаний
					</Typography>
					<Typography variant='p1'>
						В Яндексе среди рекламодателей много организаций, которые предлагают услуги по малоэтажному
						строительству. В условиях высокой конкуренции для сохранения высоких позиций в рекламной выдаче
						требуется эффективное ведение рекламных кампаний.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/6-3.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Для обеспечения эффективной работы рекламных кампаний, наша команда:
					</Typography>
					<ul className={styles.article__ul}>
						<li className={styles.article__ul__item}>
							реализовывала решения по оптимизации работы рекламных стратегий и расходов
						</li>
						<li className={styles.article__ul__item}>
							оперативно вносила изменения в торговые предложения в текстах объявлений и регулярно менять
							графическую составляющую рекламных объявлений
						</li>
						<li className={styles.article__ul__item}>
							анализировала статистику, и формировала предложения для улучшения позиций в рекламной выдаче
						</li>
						<li className={styles.article__ul__item}>
							анализировала объявления и предложения конкурентов и спрос на рынке
						</li>
						<li className={styles.article__ul__item}>предоставляла ежемесячную отчетность</li>
					</ul>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Пример рекламных креативов
					</Typography>
					<Typography variant='p1'>
						В Яндексе среди рекламодателей много организаций, которые предлагают услуги по малоэтажному
						строительству. В условиях высокой конкуренции для сохранения высоких позиций в рекламной выдаче
						требуется эффективное ведение рекламных кампаний.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/6-4.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						Работа с данными
					</Typography>
					<Typography variant='p1'>
						ля визуализации статистики рекламных кампаний используется сервис Yandex Data Lens. Индивидуально
						созданный интерактивный дашборд позволяет получать интересующие данные в удобном интерфейсе и помогает
						бизнесу принимать необходимые решения при планировании коммерческой деятельности.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/6-5.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/6-6.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
